export default "__VITE_ASSET__CqSpdgDB__"